import { render, staticRenderFns } from "./MarketplaceClaimCreateComponent.vue?vue&type=template&id=300cfadb"
import script from "./MarketplaceClaimCreateComponent.vue?vue&type=script&lang=js"
export * from "./MarketplaceClaimCreateComponent.vue?vue&type=script&lang=js"
import style0 from "./MarketplaceClaimCreateComponent.vue?vue&type=style&index=0&id=300cfadb&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports